export const PRESETS = [1, 5, 10] as const;
export const MAX_MESSAGE_LENGTH = 100;

export type TAmountMode = 'preset' | 'custom';
